import { InputAdornment } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useState } from "react"

import { useGetProductInventorySuggestions } from "../../hooks"

import { AerosAutocomplete } from "@/components/UiKit"
import { DEBOUNCE_DELAY_MS } from "@/constants/common"
import useDebounce from "@/utils/useDebounce"

export const ProductInventorySearchSuggestion: FC = () => {
  const [inputValue, setInputValue] = useState("")
  const navigate = useNavigate()
  const debouncedQuery = useDebounce(inputValue, DEBOUNCE_DELAY_MS)
  const { productOptions, isFetching } = useGetProductInventorySuggestions({ query: debouncedQuery })

  const handleChange = (value: string | null) => {
    if (!value) return

    const selectedOption = productOptions.find((option) => option.value === value)

    if (!selectedOption) return

    navigate({
      to: "/app/inventory/products/$productId",
      params: { productId: value },
    })
    setInputValue("")
  }

  const handleInputChange = (value: string) => {
    setInputValue(value)
  }

  return (
    <AerosAutocomplete<string, true>
      freeSolo
      options={productOptions}
      inputValue={inputValue}
      loading={isFetching}
      placeholder='Search for another product...'
      onChange={handleChange}
      onInputChange={handleInputChange}
      className='w-[524px]'
      slotProps={{
        textField: {
          slotProps: {
            input: {
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchOutlined className='text-gray-600' />
                </InputAdornment>
              ),
            },
          },
        },
      }}
      data-testid='product-inventory.details-page.search-field'
    />
  )
}
